export enum HttpRequestSuccessFailed {
  SUCCESS = 'succeeded',
  FAIL = 'failed',
}
